{
  "addons.addonList": "Список дополнений",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Создайте и получите свой ключ API по этой ссылке.",
  "addons.ambientWeatherDescription": "Метеостанции окружающей среды (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-ключ",
  "addons.applicationKey": "Ключ приложения",
  "addons.connect": "Подключить",
  "addons.davisApiSecret": "Секрет API",
  "addons.davisApiV2Key": "API-ключ V2",
  "addons.davisDescription": "Метеостанции Дэвиса (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Получите ключи API V2 по этой ссылке.",
  "addons.disconnect": "Отключить",
  "addons.ecowittCreateAndRetrieveKeys": "Создайте и получите ключ API и ключ приложения по этой ссылке.",
  "addons.ecowittDescription": "Ecowitt предлагает профессиональные метеостанции с Wi-Fi, беспроводные внутренние и уличные термометры, мониторы влажности, высокоточные датчики дождя, мониторы качества воздуха и многое другое.",
  "addons.helpLink": "Как подключить {provider}",
  "addons.myAcuriteAccountOnHold": "Ваш аккаунт заблокирован. Пожалуйста, введите свой пароль, чтобы повторно подключить свою учетную запись",
  "addons.myAcuriteDescription": "AcuRite — бренд метеостанций №1 в Северной Америке. Являясь лидером в области технологий измерения времени, температуры и погоды, AcuRite предоставляет вам подробную информацию о вашей внутренней и внешней среде, чтобы вы могли с уверенностью планировать свой день.",
  "addons.myAcuriteEnterCredentials": "Введите свои учетные данные My AcuRite, чтобы связать свою учетную запись My AcuRite со SmartMixin.",
  "addons.netatmoEnergy": "Нетатмо Энерджи",
  "addons.netatmoEnergyDescription": "Используйте термостат Netatmo, чтобы изменить температуру в вашем доме, не вставая с кровати или находясь на другом конце света.",
  "addons.netatmoThermostat": "Нетатмо термостат",
  "addons.netatmoWeather": "Погода Нетатмо",
  "addons.netatmoWeatherDescription": "Ваша личная метеостанция дома",
  "addons.or": "или",
  "addons.providerAccountDisconnected": "Соединение с вашей метеослужбой истекло. Подключитесь повторно, чтобы возобновить обновление данных.",
  "addons.reconnect": "Восстановить соединение",
  "addons.weatherflowCreateToken": "Создайте и получите свой токен по этой ссылке",
  "addons.weatherflowTempestDescription": "Погодная система Tempest со встроенным ветромером и дождемером",
  "addons.wundergroundApiKey": "API-ключ",
  "addons.wundergroundDescription": "Weather Underground — это глобальное сообщество людей, объединяющее данные датчиков окружающей среды, таких как метеостанции и мониторы качества воздуха, чтобы мы могли предоставлять обширные гиперлокальные данные, необходимые для реализации ваших увлечений.",
  "addons.wundergroundRetrieveApiKey": "Получите свой ключ API по этой ссылке",
  "addons.wundergroundRetrieveStationId": "Получите идентификатор вашей станции по этой ссылке",
  "addons.wundergroundStationId": "Идентификатор станции",
  "airQuality.airQuality": "Качество воздуха",
  "airQuality.airQualityIndex": "Индекс качества воздуха",
  "airQuality.aqiForecast": "Прогноз качества воздуха",
  "airQuality.co": "Монооксид углерода",
  "airQuality.dailyForecast": "Ежедневный прогноз",
  "airQuality.details": "Подробности",
  "airQuality.dominantPollutant": "Основной загрязнитель",
  "airQuality.good": "Хороший",
  "airQuality.goodDescription": "Качество воздуха считается удовлетворительным, а загрязнение воздуха представляет небольшой риск или вообще не представляет никакого риска.",
  "airQuality.hazardous": "Опасный",
  "airQuality.hazardousDescription": "Предупреждение о здоровье: любой может столкнуться с более серьезными последствиями для здоровья",
  "airQuality.indoorAirQuality": "Качество воздуха в помещении",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Умеренный",
  "airQuality.moderateDescription": "Качество воздуха приемлемое; однако некоторые загрязняющие вещества могут представлять умеренную угрозу для здоровья очень небольшого числа людей, которые необычайно чувствительны к загрязнению воздуха.",
  "airQuality.no2": "Диоксид азота",
  "airQuality.o3": "Озон",
  "airQuality.pm10": "Частицы диаметром 10 мкм и менее.",
  "airQuality.pm25": "Частицы диаметром 2,5 мкм и менее.",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Вреден для чувствительных людей.",
  "airQuality.sensitiveUnhealthyDescription": "Члены чувствительных групп могут испытывать последствия для здоровья. Широкая общественность вряд ли пострадает.",
  "airQuality.so2": "Диоксид серы",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Нездоровый",
  "airQuality.unhealthyDescription": "Каждый может начать испытывать последствия для здоровья; члены чувствительных групп могут испытывать более серьезные последствия для здоровья",
  "airQuality.veryUnhealthy": "Очень вредно для здоровья",
  "airQuality.veryUnhealthyDezscription": "Предупреждения о чрезвычайных ситуациях. Скорее всего, пострадает все население.",
  "alerts.addAlert": "Добавить оповещение",
  "alerts.addCondition": "Добавить условие",
  "alerts.alertAdded": "Оповещение успешно добавлено",
  "alerts.alertAuthorizationNotice": "Оповещения работают только в том случае, если вы разрешаете SmartMixin отображать уведомления.",
  "alerts.alertDeleted": "Оповещение успешно удалено",
  "alerts.alertEdited": "Оповещение успешно изменено",
  "alerts.alertName": "Название оповещения",
  "alerts.alertWhen": "Я хочу получать оповещения, когда:",
  "alerts.aqiGreaterThan": "AQI больше, чем",
  "alerts.aqiGreaterThanThreshold": "AQI превышает порог {value}{unit}",
  "alerts.aqiLessThan": "AQI менее",
  "alerts.aqiLessThanThreshold": "AQI ниже порога {value}{unit}",
  "alerts.atLeastOneCondition": "Вам нужно добавить хотя бы одно условие",
  "alerts.co2GreaterThan": "CO2 больше, чем",
  "alerts.co2GreaterThanThreshold": "Уровень CO2 превышает пороговое значение {value}{unit}",
  "alerts.co2LessThan": "CO2 менее",
  "alerts.co2LessThanThreshold": "CO2 ниже порогового значения {value}{unit}",
  "alerts.conditions": "Условия",
  "alerts.createAlert": "Создать оповещение",
  "alerts.dailyPrecipitationGreaterThan": "Суточные осадки больше",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Суточные осадки превышают порог {value}{unit}",
  "alerts.deleteAlert": "Удалить оповещение",
  "alerts.editAlert": "Изменить оповещение",
  "alerts.editCondition": "Изменить условие",
  "alerts.gustSpeedGreaterThan": "Скорость порыва более",
  "alerts.gustSpeedGreaterThanThreshold": "Скорость порыва превышает порог {value}{unit}",
  "alerts.gustSpeedLessThan": "Скорость порыва менее",
  "alerts.gustSpeedLessThanThreshold": "Скорость порыва ниже порога {value}{unit}",
  "alerts.heatIndexGreaterThan": "Индекс тепла более",
  "alerts.heatIndexGreaterThanThreshold": "Индекс тепла выше порогового значения {value}{unit}",
  "alerts.heatIndexLessThan": "Индекс тепла менее",
  "alerts.heatIndexLessThanThreshold": "Индекс тепла ниже порогового значения {value}{unit}",
  "alerts.humidexGreaterThan": "Гумидекс более",
  "alerts.humidexGreaterThanThreshold": "Гумидекс выше порогового значения {value}{unit}",
  "alerts.humidexLessThan": "Гумидекс менее",
  "alerts.humidexLessThanThreshold": "Гумидекс ниже порогового значения {value}{unit}",
  "alerts.humidityGreaterThan": "Влажность выше",
  "alerts.humidityGreaterThanThreshold": "Влажность выше порога {value}{unit}",
  "alerts.humidityLessThan": "Влажность менее",
  "alerts.humidityLessThanThreshold": "Влажность ниже порога {value}{unit}",
  "alerts.inProgress": "В ходе выполнения",
  "alerts.myAlerts": "Мои оповещения",
  "alerts.noConfiguredAlert": "У вас еще нет настроенных оповещений, начните добавлять их.",
  "alerts.noiseGreaterThan": "Шум выше, чем",
  "alerts.noiseGreaterThanThreshold": "Шум превышает порог {value}{unit}",
  "alerts.noiseLessThan": "Шум менее",
  "alerts.noiseLessThanThreshold": "Шум ниже порога {value}{unit}",
  "alerts.noteOnConditions": "Обратите внимание, что оповещение срабатывает, когда проверяются все приведенные ниже условия.",
  "alerts.noTriggerHistory": "Это оповещение ещё не срабатывало.",
  "alerts.pm10GreaterThan": "PM 10 больше, чем",
  "alerts.pm10GreaterThanThreshold": "PM 10 превышает пороговое значение {value}{unit}",
  "alerts.pm10LessThan": "PM 10 менее",
  "alerts.pm10LessThanThreshold": "ТЧ на 10 меньше порогового значения {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 больше, чем",
  "alerts.pm1GreaterThanThreshold": "PM 1 превышает пороговое значение {value}{unit}",
  "alerts.pm1LessThan": "ТЧ на 1 меньше",
  "alerts.pm1LessThanThreshold": "На 1 PM меньше порогового значения {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 больше, чем",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 превышает пороговое значение {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 менее",
  "alerts.pm2p5LessThanThreshold": "ТЧ на 2,5 меньше порогового значения {value}{unit}",
  "alerts.postStormSummary": "Сводка после дождя",
  "alerts.postStormSynopsisHelper": "Вы получите уведомление со сводкой после окончания каждого дождя.",
  "alerts.postStormSynopsisSoleCondition": "Сводку после грозы нельзя сочетать с другими условиями.",
  "alerts.precipitationGreaterThan": "Часовые осадки больше",
  "alerts.precipitationGreaterThanThreshold": "Часовые осадки превышают порог {value}{unit}",
  "alerts.pressureGreaterThan": "Давление больше, чем",
  "alerts.pressureGreaterThanThreshold": "Давление превышает пороговое значение {value}{unit}",
  "alerts.pressureLessThan": "Давление менее",
  "alerts.pressureLessThanThreshold": "Давление ниже порогового значения {value}{unit}",
  "alerts.rainRateGreaterThan": "Интенсивность дождя больше",
  "alerts.rainRateGreaterThanThreshold": "Интенсивность дождя превышает порог {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Солнечная радиация превышает",
  "alerts.solarRadiationGreaterThanThreshold": "Солнечное излучение превышает порог {value}{unit}",
  "alerts.solarRadiationLessThan": "Солнечная радиация менее",
  "alerts.solarRadiationLessThanThreshold": "Солнечная радиация ниже порога {value}{unit}",
  "alerts.stormChartUnavailable": "История осадков для этого дождя недоступна.",
  "alerts.stormDetail": "Сводка дождя",
  "alerts.stormDuration": "Продолжительность",
  "alerts.stormEnd": "Окончание",
  "alerts.stormPeakRate": "Максимальная интенсивность дождя",
  "alerts.stormStart": "Начало",
  "alerts.stormTotal": "Всего осадков",
  "alerts.temperatureGreaterThan": "Температура выше",
  "alerts.temperatureGreaterThanThreshold": "Температура превышает пороговое значение {value}{unit}",
  "alerts.temperatureLessThan": "Температура менее",
  "alerts.temperatureLessThanThreshold": "Температура ниже порогового значения {value}{unit}",
  "alerts.thswGreaterThan": "THSW более",
  "alerts.thswGreaterThanThreshold": "THSW выше порогового значения {value}{unit}",
  "alerts.thswLessThan": "THSW менее",
  "alerts.thswLessThanThreshold": "THSW ниже порогового значения {value}{unit}",
  "alerts.thwGreaterThan": "THW более",
  "alerts.thwGreaterThanThreshold": "THW выше порогового значения {value}{unit}",
  "alerts.thwLessThan": "THW менее",
  "alerts.thwLessThanThreshold": "THW ниже порогового значения {value}{unit}",
  "alerts.triggerHistory": "История оповещения",
  "alerts.uvGreaterThan": "УФ-индекс больше, чем",
  "alerts.uvGreaterThanThreshold": "УФ-индекс превышает пороговое значение {value}{unit}",
  "alerts.uvLessThan": "УФ-индекс менее",
  "alerts.uvLessThanThreshold": "УФ-индекс меньше порогового значения {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видимость превышает порог {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видимость меньше порога {value}{unit}",
  "alerts.visiblityGreaterThan": "Видимость более",
  "alerts.visiblityLessThan": "Видимость менее",
  "alerts.whichMeasure": "О какой мере вы хотите получать оповещения?",
  "alerts.whichModule": "Какой модуль вы бы хотели, чтобы вас предупредили?",
  "alerts.windChillGreaterThan": "Холодный ветер более",
  "alerts.windChillGreaterThanThreshold": "Холодный ветер выше порогового значения {value}{unit}",
  "alerts.windChillLessThan": "Холодный ветер менее",
  "alerts.windChillLessThanThreshold": "Холодный ветер ниже порогового значения {value}{unit}",
  "alerts.windSpeedGreaterThan": "Скорость ветра более",
  "alerts.windSpeedGreaterThanThreshold": "Скорость ветра превышает порог {value}{unit}",
  "alerts.windSpeedLessThan": "Скорость ветра менее",
  "alerts.windSpeedLessThanThreshold": "Скорость ветра ниже порога {value}{unit}",
  "astral.astronomicalSunPhase": "Астрономический {sunPhase}",
  "astral.civilSunPhase": "Гражданский {sunPhase}",
  "astral.dawn": "Рассвет",
  "astral.dusk": "Сумерки",
  "astral.firstQuarter": "Первая четверть",
  "astral.fullMoon": "Полнолуние",
  "astral.lastQuarter": "Последняя четверть",
  "astral.moon": "Луна",
  "astral.moonPhases": "Фазы Луны",
  "astral.moonrise": "Восход луны",
  "astral.moonset": "Заход Луны",
  "astral.nauticalSunPhase": "Морской {sunPhase}",
  "astral.newMoon": "Новолуние",
  "astral.noon": "Полдень",
  "astral.remainingDaylight": "Оставшийся дневной свет",
  "astral.sunrise": "Восход",
  "astral.sunriseAndSunset": "Восход и закат",
  "astral.sunriseAt": "Восход в {time}",
  "astral.sunset": "Закат",
  "astral.sunsetAt": "Закат в {time}",
  "astral.totalDaylight": "Общий дневной свет",
  "astral.waningCrescent": "Убывающая Луна",
  "astral.waningGibbous": "Убывающая луна",
  "astral.waxingCrescent": "Растущий серп",
  "astral.waxingGibbous": "Растущая луна",
  "auth.alreadyHaveAccount": "Уже есть аккаунт?",
  "auth.authContainerTagline": "Ваша персональная панель погоды. Подключите свои станции и получайте данные в реальном времени под рукой.",
  "auth.backToLogin": "Вернуться к входу",
  "auth.catchPhrase": "Платформа метеорологической разведки",
  "auth.checkYourEmail": "Проверьте вашу электронную почту",
  "auth.continueWithApple": "Продолжить с Apple",
  "auth.continueWithFacebook": "Продолжить с Facebook",
  "auth.continueWithGoogle": "Продолжить с Google",
  "auth.email": "Адрес электронной почты",
  "auth.emailRequiredLoginFacebook": "Требуется разрешение на использование электронной почты.",
  "auth.emailVerification": "Подтверждение адреса электронной почты",
  "auth.emailVerificationFailure": "Возникла проблема с подтверждением вашей электронной почты.",
  "auth.emailVerificationSuccess": "Ваш адрес электронной почты успешно подтвержден.",
  "auth.firstName": "Имя",
  "auth.forgotPassword": "Забыли пароль?",
  "auth.forgotPasswordSubtitle": "Введите адрес электронной почты, и мы отправим вам ссылку для сброса пароля.",
  "auth.lastName": "Фамилия",
  "auth.login": "Войти",
  "auth.loginSubtitle": "С возвращением! Пожалуйста, введите свои данные.",
  "auth.loginToSmartMixinDescription": "Введите свои учетные данные SmartMixin, чтобы получить доступ к своей учетной записи.",
  "auth.logout": "Выйти",
  "auth.logoutConfirmation": "Вы действительно хотите выйти?",
  "auth.noAccountYet": "Еще нет аккаунта?",
  "auth.or": "или",
  "auth.password": "Пароль",
  "auth.passwordAgain": "Пароль еще раз",
  "auth.passwordReset": "Восстановление пароля",
  "auth.passwordResetSuccess": "Ваш пароль был успешно изменен.",
  "auth.register": "Зарегистрироваться",
  "auth.registerDescription": "Создайте бесплатный аккаунт SmartMixin для подключения ваших метеостанций, отслеживания погодных данных и доступа к мощным аналитическим инструментам.",
  "auth.registerSubtitle": "Создайте аккаунт, чтобы начать.",
  "auth.registerSuccess": "Вы успешно зарегистрировались! Мы только что отправили вам ссылку для подтверждения на адрес {emailAddress} с дальнейшими инструкциями.",
  "auth.restorePassword": "Восстановить пароль",
  "auth.restorePasswordSuccess": "Мы только что отправили вам ссылку для сброса пароля на адрес {emailAddress} с дальнейшими инструкциями.",
  "auth.sendReset": "Отправить инструкции по сбросу",
  "auth.socialAccount": "или используйте свою учетную запись",
  "auth.welcome": "Добро пожаловать в СмартМиксин",
  "auth.welcomeBack": "Добро пожаловать!",
  "calendar.april": "Апрель",
  "calendar.august": "Август",
  "calendar.dateFormat": "Формат даты",
  "calendar.day": "День",
  "calendar.december": "Декабрь",
  "calendar.end": "Конец",
  "calendar.february": "Февраль",
  "calendar.hours": "Часы",
  "calendar.hoursShort": "часы",
  "calendar.january": "Январь",
  "calendar.july": "Июль",
  "calendar.june": "Июнь",
  "calendar.last24Hours": "Последние 24 часа",
  "calendar.last30Days": "Последние 30 дней",
  "calendar.last7Days": "Последние 7 дней",
  "calendar.march": "Март",
  "calendar.max": "Макс",
  "calendar.may": "Май",
  "calendar.month": "Месяц",
  "calendar.months": "месяцы",
  "calendar.november": "Ноябрь",
  "calendar.october": "Октябрь",
  "calendar.oneDay": "1 день",
  "calendar.oneHour": "1 час",
  "calendar.oneMonth": "1 месяц",
  "calendar.oneWeek": "1 неделя",
  "calendar.previous24Hours": "Предыдущие 24 часа",
  "calendar.previous30Days": "Предыдущие 30 дней",
  "calendar.previous7Days": "Предыдущие 7 дней",
  "calendar.previousDay": "Прошлый день",
  "calendar.previousMonth": "Предыдущий месяц",
  "calendar.previousWeek": "Предыдущая неделя",
  "calendar.previousYear": "Предыдущий год",
  "calendar.sameDayLastYear": "В тот же день в прошлом году",
  "calendar.sameMonthLastYear": "Тот же месяц прошлого года",
  "calendar.selectADate": "Выберите дату",
  "calendar.selectAggregation": "Выберите отображаемое значение",
  "calendar.selectAMonth": "Выберите месяц",
  "calendar.selectAYear": "Выберите год",
  "calendar.selectGranularity": "Выберите степень детализации",
  "calendar.selectTimescale": "Выберите шкалу времени",
  "calendar.september": "Сентябрь",
  "calendar.sixHours": "6-часовой",
  "calendar.start": "Начало",
  "calendar.thirtyMinutes": "30 минут",
  "calendar.threeHours": "3-часовой",
  "calendar.use24HourFormat": "Используйте 24-часовой формат",
  "calendar.week": "Неделя",
  "calendar.year": "Год",
  "calendar.yesterday": "Вчера",
  "common.accountDeleted": "Ваша учетная запись успешно удалена.",
  "common.accountOnHold": "Соединение вашей учётной записи истекло. Подключитесь повторно, чтобы возобновить обновление данных.",
  "common.add": "Добавить",
  "common.addAStation": "Добавить станцию",
  "common.addToFavorites": "Добавить в избранное",
  "common.addYourOwnStation": "Добавьте свою станцию",
  "common.alreadyPremium": "У вас уже есть премиум-аккаунт!",
  "common.alsoAvailableOn": "Также доступно на:",
  "common.altitude": "Высота",
  "common.analysis": "Анализ",
  "common.aroundMe": "Вокруг меня",
  "common.articleCount": "{count, plural, one {# статья} few {# статьи} many {# статей} other {# статей}}",
  "common.articleNotFound": "Статья не найдена",
  "common.articleNotFoundDescription": "Статья, которую вы ищете, не существует.",
  "common.average": "Средний",
  "common.averageOverThePeriod": "В среднем за период",
  "common.away": "Прочь",
  "common.back": "Назад",
  "common.backToHelpCenter": "Вернуться в центр помощи",
  "common.backToHome": "Вернуться на Главную",
  "common.bad": "Плохой",
  "common.batteryLevel": "Уровень заряда батареи",
  "common.bestValue": "Лучшее Предложение",
  "common.billingDetailsAndroid": "Если вы отмените подписку за 24 часа до истечения бесплатного ознакомительного периода, с вас не будет взиматься плата за бесплатную пробную версию. По окончании пробного периода вы можете в любое время отменить подписку на SmartMixin через настройки своей учетной записи в Google Play, или она будет автоматически продлена. Это необходимо сделать за 24 часа до окончания периода подписки, чтобы избежать взимания дополнительной платы, указанной на кнопке выше. Плата за подписку будет списана с вашей учетной записи в Google Play при подтверждении покупки и в начале каждого срока продления.",
  "common.billingDetailsIos": "Если вы отмените подписку за 24 часа до истечения бесплатного ознакомительного периода, с вас не будет взиматься плата за бесплатную пробную версию. По окончании пробного периода вы можете в любое время отменить подписку на SmartMixin через настройки своей учетной записи в App Store, или она будет автоматически продлена. Это необходимо сделать за 24 часа до окончания периода подписки, чтобы избежать взимания дополнительной платы, указанной на кнопке выше. Плата за подписку будет списана с вашей учетной записи в App Store при подтверждении покупки и в начале каждого срока продления.",
  "common.boilerOn": "Котел ВКЛ.",
  "common.browseByCategory": "Просмотр по категориям",
  "common.calendarView": "Просмотр календаря",
  "common.cancel": "Отмена",
  "common.cannotBeEmpty": "Это поле не может быть пустым.",
  "common.cardDetails": "Детали карты",
  "common.categoryNotFound": "Категория не найдена",
  "common.categoryNotFoundDescription": "Эта категория не существует или не содержит статей.",
  "common.charts": "Графики",
  "common.chartView": "Представление диаграммы",
  "common.clearRecentLocations": "Очистить все",
  "common.close": "Закрыть",
  "common.comparison": "Сравнение",
  "common.contactMe": "Свяжитесь со мной",
  "common.currentDay": "Сегодня",
  "common.currentLocation": "Текущее местоположение",
  "common.currentObservations": "Текущие наблюдения",
  "common.currentRainEvent": "Текущий дождь",
  "common.currentRate": "Текущий курс",
  "common.currentWeatherConditions": "Текущие условия",
  "common.customizeComparisonMetrics": "Настройка показателей",
  "common.customizeComparisonMetricsDescription": "Перетащите элементы, чтобы переупорядочить метрики сравнения. Коснитесь значка глаза, чтобы показать или скрыть показатели.",
  "common.customizeDashboard": "Настроить",
  "common.customizeDashboardDescription": "Перетащите элементы, чтобы изменить порядок панели. Нажмите на значок глаза, чтобы показать или скрыть разделы.",
  "common.customizedStationName": "Индивидуальное название станции",
  "common.dailyForecast": "Ежедневный прогноз",
  "common.dashboard": "Панель приборов",
  "common.default": "По умолчанию",
  "common.defaultForecastModelChip": "По умолчанию · {name}",
  "common.delete": "Удалить",
  "common.deleteAccount": "Удалить свой аккаунт",
  "common.deleteAccountConfirmation": "Вы уверены, что хотите удалить свою учетную запись? Это действие необратимо.",
  "common.deleteAccountDescription": "Это действие удалит вашу учетную запись и всю вашу информацию. Пути назад нет.",
  "common.details": "Подробности",
  "common.edit": "Редактировать",
  "common.editor": "редактор",
  "common.endTime": "Время окончания",
  "common.exitFullscreen": "Выйти из полноэкранного режима",
  "common.exploreWeatherMap": "Изучить Карту Погоды",
  "common.favoriteLocations": "Фавориты",
  "common.favoriteLocationsEmpty": "Вы можете добавить до 5 любимых мест.",
  "common.favoriteStations": "Любимые станции",
  "common.feedbackHelpsImprove": "Ваши отзывы помогают нам улучшать наши справочные статьи.",
  "common.feedbackReasonNotAnswer": "Не отвечает на мой вопрос",
  "common.feedbackReasonOutdated": "Информация устарела",
  "common.feedbackReasonUnclear": "Инструкции непонятны",
  "common.feedbackWhatWentWrong": "В чём была проблема?",
  "common.filterStationDescription": "Не отображайте станции с ненадежными измерениями",
  "common.filterStations": "Фильтровальные станции",
  "common.filterStationSourceDescription": "Выберите поставщиков станций, которых вы хотите отобразить на карте.",
  "common.findStationsNearYou": "Найти станции поблизости",
  "common.firmwareVersion": "Версия прошивки",
  "common.forecast": "Прогноз",
  "common.forecastComparisonDescription": "Легко сравнивайте результаты прогнозной модели из нескольких источников.",
  "common.forecastModelComparison": "Сравнение прогнозных моделей",
  "common.forecastModelCoverage": "Охват",
  "common.forecastModelDescription": "Описание",
  "common.forecastModelDescription_AROME": "Высокоразрешающая конвекционно-разрешающая модель Météo France над Западной Европой с разрешением 1,3 км. Лучшая в своем классе для краткосрочных прогнозов во Франции; обновляется каждые три часа.",
  "common.forecastModelDescription_ARPEGE_EU": "Европейский вложенный домен модели ARPEGE Météo France с разрешением 10 км. Среднесрочные прогнозы над Европой, обновляются четыре раза в день.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Глобальная численная модель погоды Météo France с разрешением 25 км, работает до примерно 4 дней. Обновляется четыре раза в день.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI от DMI: модель, допускающая конвекцию, над северо-западной Европой — Дания, Бенилюкс, Ирландия, Великобритания и Скандинавия — с разрешением 2 км, работает до 60 часов, обновляется восемь раз в день. Содержит изменённые открытые данные DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Глобальная детерминистическая прогностическая система Environment Canada: всемирная среднесрочная модель с разрешением 15 км, работает до 10 дней, обновляется дважды в день.",
  "common.forecastModelDescription_EC_HRDPS": "Детерминистическая прогностическая система высокого разрешения Environment Canada: модель, допускающая конвекцию, над Канадой и северной частью США с разрешением 2,5 км, работает до 48 часов, обновляется четыре раза в день.",
  "common.forecastModelDescription_EC_RDPS": "Региональная детерминистическая прогностическая система Environment Canada: среднесрочная модель над Северной Америкой с разрешением 10 км, обновляется четыре раза в день.",
  "common.forecastModelDescription_ECMWF_HRES": "Флагманская модель высокого разрешения (IFS) Европейского центра среднесрочных прогнозов погоды, широко признанная лучшей глобальной прогностической системой в мире. Покрывает всю планету с разрешением 25 км на срок до 15 дней, обновляется четыре раза в сутки. Содержит изменённые открытые данные ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Флагманская среднесрочная глобальная модель NOAA. Покрывает всю планету с разрешением 25 км до 16 дней, обновляется четыре раза в день.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh от NOAA: конвекционно-разрешающая модель над континентальной частью США с разрешением 3 км, обновляется ежечасно. Лучше всего подходит для очень краткосрочных прогнозов гроз и сильной погоды.",
  "common.forecastModelDescription_ICON": "Глобальная модель ICON от DWD с разрешением 13 км, охватывающая всю планету на срок до 7,5 суток, обновляется четыре раза в день. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I от ItaliaMeteo, работающая совместно с ARPAE: модель, допускающая конвекцию, над Италией с разрешением 2,2 км, работает до 72 часов, обновляется два раза в день. Содержит открытые данные ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Контрольный прогон ICON-CH1-EPS от MeteoSwiss: модель, допускающая конвекцию, над Альпами с разрешением 1 км, работает до 33 часов, обновляется каждые три часа.",
  "common.forecastModelDescription_ICON_CH2": "Контрольный прогон ICON-CH2-EPS от MeteoSwiss: модель, допускающая конвекцию, над Альпами — Швейцария и прилегающий альпийский регион — с разрешением 2,1 км, работает до 120 часов, обновляется четыре раза в день.",
  "common.forecastModelDescription_ICON_DE": "Высокоразрешающая конвекционно-разрешающая модель DWD над Германией и окружающими странами с разрешением 2,2 км. Краткосрочные прогнозы обновляются дважды в день. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Европейский вложенный домен модели ICON DWD с разрешением 7 км, охватывающий Европу и Северную Атлантику. Среднесрочные прогнозы обновляются четыре раза в день. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Открытая служба прогноза погоды Норвежского метеорологического института, сочетающая высокоразрешающие скандинавские модели с данными ECMWF для предоставления глобальных прогнозов на срок до 10 дней.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Вложенный домен AROME над французскими Антильскими островами (Гваделупа, Мартиника) с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Вложенный домен AROME над Французской Гвианой с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Вложенный домен AROME над Новой Каледонией с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Вложенный домен AROME над Французской Полинезией с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Вложенный домен AROME над Реюньоном и Майоттой с разрешением 2,5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "common.forecastModelDescription_NAM_CONUS": "Вложенный домен модели North American Mesoscale NOAA над континентальной частью США с разрешением 5 км. Краткосрочные прогнозы обновляются четыре раза в день.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Модель North American Mesoscale NOAA, охватывающая всю Северную Америку с разрешением 32 км. Обновляется четыре раза в день.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Флагманский прогноз SmartMixin. Для каждого часа в вашем местоположении мы выбираем лучшую доступную модель — обычно высокоразрешающую региональную модель там, где она существует (AROME во Франции, ICON-D2 в Германии, HRRR в США, ARPEGE Europe по всему континенту…) и возвращаемся к глобальной модели в других местах — затем заполняем любые пробелы из соседних источников. Результат — единый бесшовный прогноз, охватывающий любую точку мира на срок до 14 дней, автоматически обновляемый каждый раз, когда обновляется любая из основополагающих моделей.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Собственный глобальный прогноз Weatherflow, объединяющий несколько численных моделей погоды с наблюдениями его сети метеостанций Tempest. Глобальный горизонт 10 дней.",
  "common.forecastModelDetailTitle": "Модель прогноза",
  "common.forecastModelScopeGlobal": "Глобальная",
  "common.forecastModelScopeGlobalDescription": "Эта модель охватывает всю планету.",
  "common.forecastModelScopeRegional": "Региональная",
  "common.forecastModelScopeRegionalDescription": "Эта модель охватывает только определенный регион.",
  "common.forecastModelSpecifications": "Характеристики",
  "common.forecastSources": "Источники прогнозов",
  "common.freeAccount": "Бесплатный аккаунт",
  "common.freeSubscription": "Бесплатная премиум-подписка",
  "common.freeTrialForPeriod": "Бесплатная пробная версия на {period} дн.",
  "common.frequency": "Частота",
  "common.full": "Полный",
  "common.fullscreen": "Полноэкранный режим",
  "common.getStartedFree": "Начать Бесплатно",
  "common.getUnlimitedAccess": "Неограниченный доступ к:",
  "common.good": "Хороший",
  "common.hail": "Град",
  "common.help": "Помощь",
  "common.helpCategoryAccount": "Аккаунт",
  "common.helpCategoryBilling": "Оплата",
  "common.helpCategoryGettingStarted": "Начало работы",
  "common.helpCategoryProviders": "Провайдеры",
  "common.helpCategoryStations": "Станции",
  "common.helpCategoryTroubleshooting": "Устранение неполадок",
  "common.helpCenter": "Центр помощи",
  "common.helpCenterDescription": "Найдите ответы на часто задаваемые вопросы и узнайте, как максимально эффективно использовать SmartMixin.",
  "common.hg": "Морозный страж",
  "common.hidden": "Скрытые",
  "common.hiddenSensors": "Скрытые датчики",
  "common.hiddenStations": "Скрытые станции",
  "common.hiddenStationsDescription": "Вы можете снова показать станцию, нажав на значок глаза рядом с ней.",
  "common.high": "Высокий",
  "common.home": "Дом",
  "common.homeConnectService": "Есть метеостанция? Подключите свой сервис",
  "common.homeInformation": "Домашняя информация",
  "common.homeIntroduction": "Начните подключать свои внешние учетные записи, чтобы пользоваться функциями SmartMixin.",
  "common.homeName": "Домашнее имя",
  "common.homeSubtitle": "Ваша погода — всё в одном месте",
  "common.horizon": "Горизонт",
  "common.horizonValue": "до {value} часов",
  "common.iDontKnowYet": "я еще не знаю",
  "common.indoor": "В помещении",
  "common.lastRainEvent": "Последний дождь",
  "common.lastUpdate": "Последнее обновление",
  "common.legendHeavy": "Сильный",
  "common.legendLight": "Слабый",
  "common.legendLightningHelp": "Цвет показывает возраст каждой молнии за последние {minutes} минут — самые новые белым, самые старые тёмно-красным.",
  "common.legendNewest": "Самые новые",
  "common.legendOldest": "Самые старые",
  "common.legendStationsHelp": "Цвет маркера отражает значение выбранного показателя.",
  "common.lightningDataAttribution": "Данные о молниях: Blitzortung.org",
  "common.lightningStrikes": "Удары молний",
  "common.lightningStrikesDescription": "Показывать удары молний на карте в реальном времени",
  "common.linkToSection": "Ссылка на этот раздел",
  "common.loading": "Загрузка",
  "common.location": "Расположение",
  "common.locationAddedToFavorites": "Место добавлено в фавориты",
  "common.locationNotGranted": "Разрешение на местоположение не предоставляется. Пожалуйста, разрешите доступ к вашему местоположению в настройках устройства.",
  "common.locationRemovedFromFavorites": "Место удалено из фаворитов",
  "common.locations": "Локации",
  "common.low": "Низкий",
  "common.manage": "Управление",
  "common.manageAccount": "Управлять счетом",
  "common.manageMySubscription": "Управлять моей подпиской",
  "common.manageSensors": "Управление датчиками",
  "common.manageSensorsDescription": "Перетаскивайте элементы для изменения порядка датчиков. Нажмите на значок глаза, чтобы показать или скрыть датчики. Нажмите на название, чтобы переименовать.",
  "common.manualBoost": "Ручной буст",
  "common.manualSetpointUntil": "Ручная установка до тех пор, пока",
  "common.mapLayers": "Слои карты",
  "common.mapLegend": "Легенда карты",
  "common.maxFavoriteLocationsReached": "Вы можете иметь только до 5 любимых мест. Удалите один, чтобы добавить другой.",
  "common.maximum": "Максимум",
  "common.measureToDisplay": "Измерить для отображения",
  "common.medium": "Середина",
  "common.meshSize": "Размер сетки",
  "common.minimum": "Минимум",
  "common.minRead": "{minutes} мин чтения",
  "common.modifyFavoriteStations": "Измените любимые станции",
  "common.modifyFavoriteStationsDescription": "Вы можете переупорядочить свои любимые станции, перетаскивая их. Вы также можете удалить их из списка.",
  "common.moduleType": "Тип модуля",
  "common.monthTotal": "Всего за месяц",
  "common.more": "Более",
  "common.moreInformation": "Больше информации",
  "common.myLocation": "Моё местоположение",
  "common.nearbyWeatherStations": "Близлежащие погодные станции",
  "common.next": "Следующий",
  "common.nextHours": "Следующие часы",
  "common.no": "Нет",
  "common.noAccountNeeded": "Аккаунт не требуется",
  "common.noDataForThisPeriod": "Нет данных за этот период",
  "common.noLocationsFound": "Места не найдены",
  "common.noNetatmoWeatherStationYet": "У вас еще нет метеостанции Netatmo.",
  "common.noOutdoorModule": "Функционального вызывного модуля для этой станции нет.",
  "common.noSearchResults": "Нет статей, соответствующих вашему запросу",
  "common.noStationsFound": "Станции не найдены",
  "common.noThermostatYet": "У вас еще нет термостата.",
  "common.notNow": "Не сейчас",
  "common.notPurchasedYet": "Кажется, его еще не купили.",
  "common.noWeatherStation": "Нет метеостанции",
  "common.noWeatherStationYet": "У вас еще нет метеостанции.",
  "common.numberOfActiveWarnings": "{warning_count} активных предупреждений о погоде",
  "common.onThisPage": "На этой странице",
  "common.openSettings": "Откройте настройки",
  "common.orChooseMonthly": "Или выберите ежемесячно:",
  "common.outdatedModule": "Данные для этого модуля устарели.",
  "common.outdoor": "Открытый",
  "common.outdoorTemperature": "Температура наружного воздуха",
  "common.pageNotFound": "Страница Не Найдена",
  "common.pageNotFoundDescription": "Страница, которую вы ищете, не существует или была перемещена.",
  "common.passwordUpdated": "Пароль успешно обновлен.",
  "common.personalWeatherIntelligence": "Ваш Персональный Погодный Интеллект",
  "common.platformMobileApp": "Мобильное приложение",
  "common.platformMobileOnly": "Только в мобильном приложении",
  "common.platformWebApp": "Веб-приложение",
  "common.platformWebOnly": "Только в веб-приложении",
  "common.popularArticles": "Популярные статьи",
  "common.premiumAccount": "Премиум аккаунт",
  "common.premiumDescription": "Премиум-подписка открывает множество дополнительных функций, таких как расширенный анализ погоды, сравнение диаграмм, региональные модели прогнозов и многое другое.",
  "common.premiumFeatureAlerts": "Погодные Оповещения",
  "common.premiumFeatureAnalysis": "Расширенный Анализ Погоды",
  "common.premiumFeatureCharts": "Сравнение Графиков",
  "common.premiumFeatureExport": "Экспорт Данных",
  "common.premiumFeatureForecast": "Региональные Модели Прогнозов",
  "common.premiumFeatureNotification": "Виджет Строки Состояния",
  "common.premiumFeatureTitle": "Премиум Функция",
  "common.premiumFeatureWidgets": "Виджеты главного экрана",
  "common.pressureSummary": "Сводка давления",
  "common.previous": "Предыдущий",
  "common.previousHours": "Предыдущие часы",
  "common.profileUpdated": "Профиль успешно обновлен.",
  "common.purchasedNetatmoPro": "Ранее вы приобрели Netatmo Pro ({date}). Это дает вам доступ к набору премиум-функций. Подпишитесь на одно из следующих предложений, если хотите получить доступ ко всем премиум-функциям.",
  "common.radarDataAttribution": "Данные радара: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Дождь",
  "common.rainEvents": "Дождевые события",
  "common.rainfallMeasurement": "Измерение количества осадков",
  "common.rainRadar": "Дождевой радар",
  "common.rainRadarDescription": "Отображение наложения радара дождя на карте",
  "common.rainSummary": "Сводка дождя",
  "common.range": "Диапазон",
  "common.recentLocations": "Недавний",
  "common.recentLocationsEmpty": "Ваша недавняя история пуста.",
  "common.recentStations": "Недавние станции",
  "common.relatedArticles": "Связанные статьи",
  "common.relay": "Реле",
  "common.removeFromFavorites": "Удалить из Избранного",
  "common.renameSensors": "Переименование датчиков",
  "common.resetZoom": "Сбросить масштаб",
  "common.restorePurchase": "Восстановить покупку",
  "common.room": "Комната",
  "common.rooms": "Номера",
  "common.savingsPercent": "Экономия {percent}%",
  "common.searchArticles": "Поиск статей...",
  "common.searchForALocation": "Поиск места...",
  "common.searchForLocation": "Поиск местоположения",
  "common.searchForWeatherStation": "Поиск метеостанции",
  "common.searchResults": "Результаты поиска",
  "common.searchResultsEmpty": "Результаты не обнаружены.",
  "common.searchResultsFound": "{count, plural, one {Найден # результат} few {Найдено # результата} many {Найдено # результатов} other {Найдено # результата}}",
  "common.searchStationsDescription": "Введите город, адрес или название места, чтобы найти метеостанции поблизости.",
  "common.searchStationsHint": "Используйте строку поиска выше, чтобы найти метеостанции в любой точке мира.",
  "common.selectStationForComparison": "Выберите станцию ​​для сравнения",
  "common.selectWeatherForecastProvider": "Пожалуйста, выберите поставщика погоды",
  "common.serialNumber": "Серийный номер",
  "common.share": "Поделиться",
  "common.shareOutdoorMeasures": "Поделитесь своими мероприятиями на свежем воздухе",
  "common.shareOutdoorMeasuresDescription": "Участвуйте в сообществе SmartMixin, делая свои мероприятия на открытом воздухе видимыми для других. Внутренние меры никогда не будут разглашаться.",
  "common.shareYourWeather": "Поделитесь своей погодой",
  "common.signalStrength": "Сила сигнала",
  "common.skip": "Пропустить",
  "common.smartThermostat": "Умный термостат",
  "common.smartValve": "Умный клапан",
  "common.snow": "Снег",
  "common.start": "Начать",
  "common.startFreeTrial": "Начать Бесплатную Пробную Версию",
  "common.startTime": "Время начала",
  "common.station": "станция",
  "common.stationAddedToFavorites": "Станция добавлена ​​в избранное",
  "common.stationComparison": "Сравнение станций",
  "common.stationComparisonDescription": "Сравните исторические данные о погоде с другой станцией",
  "common.stationInformation": "Информация о станции",
  "common.stationName": "Название станции",
  "common.stationObservationsDescription": "Отображение последних наблюдений с метеостанций",
  "common.stationRemovedFromFavorites": "Станция удалена из избранного",
  "common.stations": "станции",
  "common.stationsNear": "Станции рядом с",
  "common.stationType": "Тип станции",
  "common.statusOffline": "Не в сети",
  "common.statusOnline": "В сети",
  "common.statusStale": "Устаревший",
  "common.statusSyncing": "Синхронизация",
  "common.stillNeedHelp": "Всё ещё нужна помощь?",
  "common.stillNeedHelpDescription": "Если эта статья не ответила на ваш вопрос, я с радостью помогу вам напрямую.",
  "common.subscribeNow": "Подписаться сейчас - без пробного периода",
  "common.sumOverThePeriod": "Накоплено за период",
  "common.switchToPremium": "Перейти на SmartMixin Premium",
  "common.temperatureShort": "Темп.",
  "common.temperatureSummary": "Сводка температуры",
  "common.thankYouForFeedback": "Спасибо за ваш отзыв!",
  "common.thenPrice": "затем {price}",
  "common.timeSelection": "Выбор времени",
  "common.timezone": "Часовой пояс",
  "common.totalDuration": "Общая продолжительность",
  "common.tryAnotherLocation": "Мы не смогли найти метеостанции рядом с этим местом. Попробуйте поискать в другом районе.",
  "common.unknown": "Неизвестный",
  "common.untilChanged": "Пока не изменилось",
  "common.untilTime": "До {time}",
  "common.updateAvailable": "Доступно обновление",
  "common.updateAvailableOpenAppStore": "Нажмите, чтобы открыть App Store",
  "common.updateAvailableOpenGooglePlay": "Нажмите, чтобы открыть Google Play",
  "common.updateAvailableVersion": "Доступно обновление: v{version}",
  "common.upgrade": "Обновление",
  "common.upgradeRequiredAndroid": "Требуется обновление вашего приложения. Посетите Google Play для обновления.",
  "common.upgradeRequiredIos": "Требуется обновление вашего приложения. Посетите App Store для обновления.",
  "common.validate": "Подтвердить",
  "common.validEmail": "Требуется действительный адрес электронной почты.",
  "common.very_low": "Очень низкий",
  "common.visitNetatmoWebsite": "Посетите сайт Netatmo",
  "common.wasArticleHelpful": "Была ли эта статья полезной?",
  "common.weatherCondition": "Погодные условия",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain — это дополнительный источник данных, предоставляемый через систему погоды Tempest на базе технологии Nearcast. Данные NC Rain — это оценка среднего накопления осадков вокруг вашего Tempest на уровне района.",
  "common.weatherForecastModels": "Модели прогноза погоды",
  "common.weatherIntelligencePlatform": "Платформа Погодного Интеллекта",
  "common.weatherMap": "Карта погоды",
  "common.weatherMapMetaDescription": "SmartMixin предлагает интерактивные карты погоды и радара для метеорологических условий по всему миру.",
  "common.weatherObservations": "Наблюдения за погодой",
  "common.weatherStation": "Метеостанция",
  "common.weatherStations": "Метеостанции",
  "common.welcome": "Добро пожаловать в СмартМиксин!",
  "common.whenBackHome": "Когда вы вернётесь домой?",
  "common.wifiStrength": "Мощность Wi-Fi",
  "common.wind": "Ветер",
  "common.windMeasurement": "Измерение ветра",
  "common.windSpeed": "Скорость ветра",
  "common.windSummary": "Сводка по ветру",
  "common.yearToDate": "С начала года",
  "common.yes": "Да",
  "common.zoomImage": "Увеличить изображение",
  "forecastMaps.addColor": "Добавить цвет",
  "forecastMaps.addLayer": "Добавить слой",
  "forecastMaps.autoPreview": "Авто",
  "forecastMaps.backToMaps": "Назад к картам",
  "forecastMaps.browseMaps": "Обзор карт",
  "forecastMaps.build": "Сгенерировать",
  "forecastMaps.buildCompleted": "Генерация завершена",
  "forecastMaps.builderMetaDescription": "Создавайте собственные прогнозные карты из слоёв метеорологических моделей.",
  "forecastMaps.builderTitle": "Конструктор карт",
  "forecastMaps.buildFailed": "Не удалось сгенерировать. Попробуйте ещё раз.",
  "forecastMaps.buildNotPossible": "Эту карту пока нельзя сгенерировать — нет доступных прогнозных данных.",
  "forecastMaps.buildProgress": "Отрисовка… {completed}/{total} шагов",
  "forecastMaps.buildStarting": "Запуск генерации…",
  "forecastMaps.byModel": "По модели",
  "forecastMaps.byZone": "По зоне",
  "forecastMaps.colormap": "Цветовая шкала",
  "forecastMaps.colormapCustom": "Свои цвета",
  "forecastMaps.colormapGroupDomain": "Метеорологические шаблоны",
  "forecastMaps.colormapGroupMatplotlib": "Научные шаблоны",
  "forecastMaps.colorScale": "Цветовая шкала",
  "forecastMaps.comingSoon": "Этот раздел скоро появится.",
  "forecastMaps.contourLevels": "Уровни изолиний",
  "forecastMaps.countryCanada": "Канада",
  "forecastMaps.countryFrance": "Франция",
  "forecastMaps.countryGermany": "Германия",
  "forecastMaps.countryItaly": "Италия",
  "forecastMaps.countryScandinavia": "Скандинавия",
  "forecastMaps.countrySpain": "Испания",
  "forecastMaps.countrySwitzerland": "Швейцария",
  "forecastMaps.countryUnitedStates": "Соединённые Штаты",
  "forecastMaps.customColormapMinColors": "Своя цветовая шкала требует не менее двух цветов",
  "forecastMaps.customExtent": "Свой охват",
  "forecastMaps.deleteMap": "Удалить карту",
  "forecastMaps.deleteMapBody": "«{name}» и её отрисованные прогоны будут удалены навсегда.",
  "forecastMaps.deleteMapTitle": "Удалить эту карту?",
  "forecastMaps.displayName": "Отображаемое имя",
  "forecastMaps.downloadMp4": "Скачать MP4",
  "forecastMaps.downscaling": "Коэффициент прореживания флажков ветра",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Нарисовать область",
  "forecastMaps.east": "Восток",
  "forecastMaps.editMap": "Редактировать карту",
  "forecastMaps.exportBuilding": "Подготовка видео…",
  "forecastMaps.exportError": "Не удалось экспортировать видео. Попробуйте ещё раз.",
  "forecastMaps.exportMp4": "Экспорт MP4",
  "forecastMaps.exportNotReady": "Видео ещё не готово. Попробуйте позже.",
  "forecastMaps.extentDrawHint": "Проведите по карте, чтобы нарисовать область",
  "forecastMaps.extentInvalid": "Запад должен быть меньше востока, а юг — меньше севера",
  "forecastMaps.extentPanZoomHint": "Перемещайте и масштабируйте карту, пока область не заполнит рамку",
  "forecastMaps.flipbookView": "Анимация",
  "forecastMaps.forecastModel": "Модель прогноза",
  "forecastMaps.forkAndEdit": "Дублировать и редактировать",
  "forecastMaps.height": "Высота (дюймы)",
  "forecastMaps.hourOffset": "+{hour} ч",
  "forecastMaps.invalidHexColor": "Недопустимый цвет — используйте #RRGGBB",
  "forecastMaps.layers": "Слои",
  "forecastMaps.layerTypeBarbs": "Флажки ветра",
  "forecastMaps.layerTypeContour": "Изолинии",
  "forecastMaps.layerTypeFilledContour": "Залитые изолинии",
  "forecastMaps.layerTypeMagnitude": "Модуль",
  "forecastMaps.layerTypeRaster": "Растр",
  "forecastMaps.layerTypeVectorField": "Векторное поле",
  "forecastMaps.leave": "Выйти",
  "forecastMaps.levelsCount": "Количество",
  "forecastMaps.levelsInvalid": "Недопустимые уровни изолиний",
  "forecastMaps.levelsModeArange": "Фиксированный шаг",
  "forecastMaps.levelsModeExplicit": "Явные значения",
  "forecastMaps.levelsModeLinspace": "Равномерно распределённые (количество)",
  "forecastMaps.levelsStep": "Шаг",
  "forecastMaps.levelsValues": "Значения",
  "forecastMaps.levelsValuesHint": "Через запятую, по возрастанию",
  "forecastMaps.localTimeHint": "Показано в вашем местном времени",
  "forecastMaps.map": "Карта",
  "forecastMaps.mapDescription": "Описание",
  "forecastMaps.mapName": "Название карты",
  "forecastMaps.mapNameRequired": "Введите название",
  "forecastMaps.mapSettings": "Настройки карты",
  "forecastMaps.mapView": "Интерактивная карта",
  "forecastMaps.maxLayersReached": "Эта карта достигла максимума в {max} слоёв.",
  "forecastMaps.maxValue": "Максимальное значение",
  "forecastMaps.memoryBudgetExceeded": "Разрешение превышает бюджет отрисовки — уменьшите DPI или высоту",
  "forecastMaps.memoryBudgetUsage": "Бюджет отрисовки: {percent}%",
  "forecastMaps.metaDescription": "Анимированные прогнозные карты, построенные по расчётам моделей погоды.",
  "forecastMaps.metric": "Величина",
  "forecastMaps.metricRequired": "Выберите величину",
  "forecastMaps.metricUnavailable": "Недоступно для этой модели",
  "forecastMaps.minBelowMax": "Минимум должен быть меньше максимума",
  "forecastMaps.minMaxRequired": "Минимальное и максимальное значения обязательны для этого типа слоя",
  "forecastMaps.minValue": "Минимальное значение",
  "forecastMaps.modelNoRun": "Пока нет завершённого прогона",
  "forecastMaps.moveLayerDown": "Переместить вниз",
  "forecastMaps.moveLayerUp": "Переместить вверх",
  "forecastMaps.myMaps": "Мои карты",
  "forecastMaps.nanClipToMin": "Ограничить минимумом",
  "forecastMaps.nanMask": "Маскировать",
  "forecastMaps.nanPolicy": "Отсутствующие данные",
  "forecastMaps.nanSkip": "Пропустить",
  "forecastMaps.newMap": "Новая карта",
  "forecastMaps.noCompletedRun": "Эта карта ещё не построена. Загляните позже.",
  "forecastMaps.noLayers": "Слоёв пока нет. Добавьте слой, чтобы начать.",
  "forecastMaps.noMapsAvailable": "Прогнозные карты пока недоступны.",
  "forecastMaps.north": "Север",
  "forecastMaps.opacity": "Непрозрачность",
  "forecastMaps.overlayLegend": "Легенда",
  "forecastMaps.pause": "Пауза",
  "forecastMaps.play": "Воспроизвести",
  "forecastMaps.pointValueError": "Не удалось загрузить прогноз для этой точки.",
  "forecastMaps.pointValueLoading": "Загрузка прогноза…",
  "forecastMaps.pointValueUnavailable": "Нет данных для этого времени.",
  "forecastMaps.presets": "Шаблоны",
  "forecastMaps.preview": "Предпросмотр",
  "forecastMaps.previewEmptyHint": "Настройте хотя бы один корректный слой, чтобы отрисовать предпросмотр.",
  "forecastMaps.previewFailed": "Предпросмотр не удался",
  "forecastMaps.previewHour": "Час прогноза",
  "forecastMaps.previewRendering": "Отрисовка предпросмотра…",
  "forecastMaps.projection": "Проекция",
  "forecastMaps.projectionLambertConformal": "Коническая конформная Ламберта",
  "forecastMaps.projectionMercator": "Меркатора",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Стереографическая",
  "forecastMaps.regionEurope": "Европа",
  "forecastMaps.regionNorthAmerica": "Северная Америка",
  "forecastMaps.removeColor": "Удалить цвет",
  "forecastMaps.removeLayer": "Удалить слой",
  "forecastMaps.retry": "Повторить",
  "forecastMaps.run": "Расчёт: {run}",
  "forecastMaps.save": "Сохранить",
  "forecastMaps.selectExtentOnMap": "Выбрать область на карте",
  "forecastMaps.south": "Юг",
  "forecastMaps.title": "Прогнозные карты",
  "forecastMaps.uMetric": "U-компонента",
  "forecastMaps.unitConversion": "Преобразование единиц",
  "forecastMaps.unitNone": "Нет",
  "forecastMaps.unsavedChangesBody": "У вас есть несохранённые изменения. Выйти и отменить их?",
  "forecastMaps.unsavedChangesTitle": "Несохранённые изменения",
  "forecastMaps.useCurrentView": "Использовать текущий вид",
  "forecastMaps.useModelDomain": "Выкл.: используется вся область модели",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Величины U и V должны различаться",
  "forecastMaps.validTime": "Прогноз на {time}",
  "forecastMaps.valueBetween": "Должно быть между {min} и {max}",
  "forecastMaps.variable": "Переменная",
  "forecastMaps.viewMap": "Посмотреть карту",
  "forecastMaps.vMetric": "V-компонента",
  "forecastMaps.west": "Запад",
  "forecastMaps.windAnimation": "Анимация ветра",
  "intro.locationDescription": "Разрешите доступ к местоположению, чтобы получать точные прогнозы, адаптированные к вашему району — без универсальных прогнозов.",
  "intro.locationTitle": "Прогнозы, созданные для вас",
  "intro.notificationDescription": "Включите уведомления, чтобы получать своевременные предупреждения о погодных изменениях, которые важны для вас — дождь, снег или экстремальные условия, именно тогда, когда нужно.",
  "intro.notificationsTitle": "Никогда не пропускайте изменения погоды",
  "intro.readyDescription": "Наслаждайтесь точными прогнозами, актуальными погодными данными и информацией со станций по всему миру — всё в одном мощном приложении.",
  "intro.readyTitle": "Вы готовы!",
  "intro.welcomeDescription": "Получайте гиперлокальные прогнозы от лучших метеорологических агентств — плюс доступ к более чем 40 000 метеостанциям по всему миру, чтобы видеть реальные условия, прошлые и настоящие.",
  "intro.welcomeTitle": "Ваш прогноз погоды, заново переосмыслен",
  "landing.alerts": "Оповещения",
  "landing.alertsDescription": "Создавайте свои собственные оповещения и получайте уведомления, как только они сработают.",
  "landing.featureAlertsDescription": "Настройте пользовательские оповещения для условий, которые вас интересуют—температура, ветер, осадки и другое.",
  "landing.featureAlertsTitle": "Умные оповещения",
  "landing.featureAnalyticsDescription": "Погрузитесь в свои данные с интерактивными графиками, сравнениями бок о бок и анализом трендов за пределами базовых метрик.",
  "landing.featureAnalyticsTitle": "Мощная аналитика",
  "landing.featureExportDescription": "Загружайте свои данные в формате CSV для анализа в Excel, интеграции с другими системами или резервного копирования.",
  "landing.featureExportTitle": "Экспорт куда угодно",
  "landing.featureForecastDescription": "Сравните прогнозы более чем 10 погодных моделей, включая GFS, ECMWF, ICON и другие, чтобы увидеть, какая лучше работает для вашей локации.",
  "landing.featureForecastTitle": "Сравнение прогнозов",
  "landing.featureHistoryDescription": "Доступ к историческим данным с почасовой, дневной и месячной шкалой. Экспорт в CSV для исследований или личных архивов.",
  "landing.featureHistoryTitle": "Богатая история",
  "landing.featureMultiBrandDescription": "Подключите станции от Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow и других—всё на одной панели.",
  "landing.featureMultiBrandTitle": "Поддержка многих брендов",
  "landing.featuresSubtitle": "Создано для энтузиастов погоды, которым нужно больше, чем базовое приложение метеостанции.",
  "landing.featuresTitle": "Всё, что нужно для анализа погоды",
  "landing.finalCtaButton": "Создать бесплатный аккаунт",
  "landing.finalCtaSubtitle": "Присоединяйтесь к тысячам энтузиастов погоды, которые доверяют SmartMixin свои погодные данные.",
  "landing.finalCtaTitle": "Готовы улучшить свой погодный опыт?",
  "landing.forecastDescription": "Получите доступ к некоторым из лучших моделей прогнозов погоды и сравните их, чтобы получить собственное представление о том, какая будет погода.",
  "landing.forecasts": "Прогнозы",
  "landing.heroCta": "Начать бесплатно",
  "landing.heroDescription": "Объедините несколько метеостанций любых брендов, сравнивайте модели прогнозов и анализируйте свои данные с помощью подробных графиков и экспорта.",
  "landing.heroSecondaryCta": "Смотреть функции",
  "landing.heroTagline": "Все погодные данные. Одна платформа.",
  "landing.heroTitle": "Все погодные данные. Одна платформа.",
  "landing.pricingFeatureAdvancedMetrics": "Продвинутые метрики",
  "landing.pricingFeatureAlerts": "Пользовательские оповещения",
  "landing.pricingFeatureExport": "Экспорт данных (CSV)",
  "landing.pricingFeatureForecastComparison": "Сравнение прогнозов",
  "landing.pricingFeatureForecasts": "Модели прогнозов",
  "landing.pricingFeatureForecastsFreeTier": "1 модель",
  "landing.pricingFeatureForecastsPremiumTier": "Все модели (10+)",
  "landing.pricingFeatureReports": "Анализ и отчёты",
  "landing.pricingFeatureStationComparison": "Сравнение станций",
  "landing.pricingFeatureWidgets": "Виджеты главного экрана",
  "landing.pricingFeatureYearOverYear": "Анализ год к году",
  "landing.pricingFree": "Бесплатно",
  "landing.pricingFreeCta": "Начать",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Самый популярный",
  "landing.pricingPremium": "Премиум",
  "landing.pricingPremiumCta": "Начать",
  "landing.pricingPremiumDescription": "От 1,99 €/месяц — подпишитесь на сайте, в App Store или Google Play",
  "landing.pricingSubtitle": "Начните бесплатно, перейдите на платную версию когда понадобится больше.",
  "landing.pricingTitle": "Простые, прозрачные цены",
  "landing.smartMixinDescription": "SmartMixin — это приложение, которое обеспечивает доступ к вашей метеостанции и более чем 40 тысячам других станций по всему миру. Это поможет вам увидеть и понять данные о погоде.",
  "landing.statBrands": "Поддерживаемые бренды",
  "landing.statForecasts": "Прогнозные модели",
  "landing.statStations": "Подключенных станций",
  "landing.supportedDevices": "Поддерживаемые устройства",
  "landing.supportedDevicesDescription": "Помимо станций Всемирной метеорологической организации, SmartMixin поддерживает растущее число брендов метеостанций.",
  "landing.supportedDevicesNote": "Плюс более 40 000 государственных станций Всемирной метеорологической организации",
  "landing.supportedDevicesSubtitle": "Подключите метеостанции ведущих брендов и просматривайте все данные в одном месте.",
  "landing.supportedDevicesTitle": "Работает с вашими станциями",
  "landing.thermostatDescription": "Подключите термостат Netatmo для сопоставления режимов отопления с наружными условиями.",
  "landing.thermostatManufacturers": "Производителям термостатов также оказывается помощь в сопоставлении нагрева с условиями окружающей среды.",
  "landing.thermostatTitle": "Интеграция с умным домом",
  "landing.weatherAnalysis": "Анализ погоды",
  "landing.weatherAnalysisDescription": "SmartMixin поставляется с множеством средств визуализации данных, которые позволяют анализировать данные о погоде.",
  "landing.weatherAssistant": "Ваш помощник погоды",
  "landing.weatherAssistantDescription": "Если вас интересуют текущие, исторические или прогнозируемые погодные условия, SmartMixin предоставит вам множество полезных сведений, когда они вам понадобятся.",
  "landing.weatherForecastModels": "Модели прогноза погоды",
  "landing.weatherForecastModelsDescription": "SmartMixin обеспечивает доступ к наиболее точным моделям прогноза погоды. Вы можете легко сравнить их прогнозы и составить свою собственную идею.",
  "landing.weatherMap": "Карта погоды",
  "landing.weatherMapDescription": "Просмотрите карту и представьте, какая погода в любой точке земного шара.",
  "network.cancelError": "Запрос отменен",
  "network.connectionError": "Сервер недоступен",
  "network.networkError": "Сеть недоступна",
  "network.serverError": "Что-то пошло не так...",
  "network.timeoutError": "Время соединения вышло",
  "network.unknownError": "Неизвестная ошибка",
  "providerHints.ambientWeatherApiKey": "Создаётся в настройках вашей учётной записи на ambientweather.net.",
  "providerHints.davisApiSecret": "Показывается только один раз при создании ключа V2 API — храните в надёжном месте.",
  "providerHints.davisV2ApiKey": "Со страницы ключей V2 API на weatherlink.com.",
  "providerHints.ecowittApi": "Со страницы API вашей учётной записи Ecowitt.",
  "providerHints.ecowittApp": "Ключ приложения, также из вашей учётной записи Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Используйте email и пароль учётной записи My AcuRite — не вход в SmartMixin.",
  "providerHints.myAcuriteEmail": "Электронная почта вашей учётной записи My AcuRite — не ваш вход в SmartMixin.",
  "providerHints.myAcuritePassword": "Пароль вашей учётной записи My AcuRite.",
  "providerHints.weatherflowToken": "Персональный токен из tempestwx.com → настройки → авторизации данных.",
  "providerHints.wundergroundEditKey": "Использовать другой ключ",
  "providerHints.wundergroundKey": "Длинная строка со страницы API-ключей вашей учётной записи Weather Underground — не ваш пароль на wunderground.com.",
  "providerHints.wundergroundKeyExample": "напр. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-ключ подтверждён",
  "providerHints.wundergroundKeyVerifying": "Проверка ключа…",
  "providerHints.wundergroundNoStationsNearby": "Поблизости от этого места не найдено станций. Попробуйте ввести ID станции напрямую.",
  "providerHints.wundergroundStationId": "Любой идентификатор станции Weather Underground — ваш или публичной станции рядом с вами.",
  "providerHints.wundergroundStationIdExample": "напр. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Получите свой API-ключ Ambient Weather.",
  "providerIntro.davisStep2": "Получите свой ключ V2 API и API-секрет Davis.",
  "providerIntro.ecowittStep2": "Получите свой API-ключ и ключ приложения Ecowitt.",
  "providerIntro.getStarted": "Начать",
  "providerIntro.myAcuriteStep2": "Используйте email и пароль вашей существующей учётной записи My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Войдите в Netatmo, когда появится запрос — API-ключ не требуется.",
  "providerIntro.netatmoWeatherStep2": "Войдите в Netatmo, когда появится запрос — API-ключ не требуется.",
  "providerIntro.signupBanner": "Почти готово — создайте бесплатную учётную запись SmartMixin, чтобы подключить {provider}.",
  "providerIntro.step1": "Войдите в свою учётную запись SmartMixin (НЕ в {provider}).",
  "providerIntro.step3EmailPassword": "Введите их здесь.",
  "providerIntro.step3KeyOrToken": "Вставьте сюда.",
  "providerIntro.step3OAuth": "Авторизуйте SmartMixin во всплывающем окне.",
  "providerIntro.step3Wunderground": "Вставьте ваш API-ключ, затем выберите ближайшую станцию или введите любой ID станции.",
  "providerIntro.title": "Подключить {provider}",
  "providerIntro.weatherflowStep2": "Получите свой персональный токен Tempest.",
  "providerIntro.wundergroundBrowsePublic": "Нет станции? Просмотрите публичные",
  "providerIntro.wundergroundFindNearby": "Найти станции поблизости",
  "providerIntro.wundergroundOrEnterId": "Или введите ID станции",
  "providerIntro.wundergroundStep2": "Получите свой API-ключ Weather Underground. Затем вы сможете подключить любую станцию — свою или публичную.",
  "reports.agroMeteorology": "Агрометеорология",
  "reports.analysis": "Анализ",
  "reports.annualCumulativeRainfallComparison": "Ежегодное сравнение совокупного количества осадков",
  "reports.annualHeatingDurationComparison": "Сравнение годовой продолжительности отопления",
  "reports.annualHeatingEfficiency": "Годовая эффективность отопления",
  "reports.annualIndoorComparison": "Ежегодное сравнение внутри помещений",
  "reports.annualIndoorReport": "Годовой отчет о закрытых помещениях",
  "reports.annualOutdoorComparison": "Ежегодное сравнение на открытом воздухе",
  "reports.annualOutdoorReport": "Годовой отчет об открытом воздухе",
  "reports.annualReport": "Годовой отчет",
  "reports.annualSolarReport": "Ежегодный солнечный отчет",
  "reports.annualWaterBalance": "Годовой водный баланс",
  "reports.annualWaterBalanceCarryOver": "Перенести с предыдущего года",
  "reports.annualWaterBalanceDescription": "Водный баланс (упрощенная версия, используются только дождь и суммарное испарение) помогает управлять водоснабжением.",
  "reports.avgHumidity": "Средняя влажность",
  "reports.avgMaxTemperature": "Средняя Т°макс.",
  "reports.avgMetric": "Среднее – {metric}",
  "reports.avgMinTemperature": "Средняя Т°мин",
  "reports.avgPressure": "Среднее давление",
  "reports.avgTemperature": "Средняя температура",
  "reports.climateNormalPeriodOfRecord": "Период наблюдений ({years, plural, one {# год} few {# года} many {# лет} other {# года}})",
  "reports.climateNormals": "Климатические нормы",
  "reports.climateNormalStandardLabel": "Стандартная норма ({period})",
  "reports.climateTrendPerDecade": "Тренд температуры: {value} за десятилетие (данные за {years, plural, one {# год} few {# года} many {# лет} other {# года}})",
  "reports.coldestMonthRanking": "Самый холодный {month} за историю наблюдений",
  "reports.comfortable": "Комфортный (45 % {lessThan} влажность ≤ 60 %)",
  "reports.cumulativeRainfall": "Накопленные осадки",
  "reports.cumulativeRainfallDescription": "Отслеживайте общее количество осадков, накопившихся за выбранный период.",
  "reports.dailyMaxRainfall": "Ежедневный Макс. осадки",
  "reports.dataExport": "Экспорт данных",
  "reports.dataExportXlsxFormatDescription": "Экспортируйте все данные вашей станции в формате Excel (*.xlsx). После того, как вы нажмете кнопку, через несколько минут вы получите электронное письмо с обработанными данными.",
  "reports.daysWithFrost": "Дни с морозом",
  "reports.daysWithHeavyRain": "Дни с сильным дождём (≥ {threshold})",
  "reports.daysWithoutThaw": "Дни без оттепели",
  "reports.daysWithStrongFrost": "Дни с сильными морозами",
  "reports.emailSent": "На ваш почтовый ящик было отправлено письмо",
  "reports.frostDays": "Морозные дни",
  "reports.grasslandTemperatureSum": "Сумма температур пастбищ",
  "reports.grasslandTemperatureSumDescription": "Если сумма {threshold} превышена весной, устойчивое начало вегетации достигнуто (работает в Европе)",
  "reports.growingDegreeDays": "Градусо-дни роста",
  "reports.highPressure": "Антициклон (среднее давление ≥ 1013 мбар)",
  "reports.iceDays": "Дни без оттепели",
  "reports.indoorReport": "Внутренний отчет",
  "reports.keyFacts": "Ключевые факты",
  "reports.longestDrySpell": "Макс. период без осадков",
  "reports.longestRunOfRainyDays": "Самая длинная серия дождливых дней",
  "reports.longestRunWithoutRun": "Самая длинная пробежка без дождя",
  "reports.longestWetSpell": "Макс. период с осадками",
  "reports.lowPressure": "Низкое давление (среднее давление {lessThan} 1013 мбар)",
  "reports.maxHumidity": "Максимальная влажность",
  "reports.maxMetric": "Максимум – {metric}",
  "reports.maxPressure": "Максимальное давление",
  "reports.maxPressureMagnitude24h": "Максимальная магнитуда (/24H)",
  "reports.maxTemperature": "Максимальная температура",
  "reports.maxTempGreaterThan": "Т°макс ≥",
  "reports.maxTempMagnitude24h": "Максимальная магнитуда (/24H)",
  "reports.minHumidity": "Минимальная влажность",
  "reports.minMetric": "Минимум – {metric}",
  "reports.minPressure": "Минимальное давление",
  "reports.minPressureMagnitude24h": "Минимальная величина (/24H)",
  "reports.minTemperature": "Минимальная температура",
  "reports.minTempMagnitude24h": "Минимальная величина (/24H)",
  "reports.monthlyHeatingEfficiency": "Ежемесячная эффективность отопления",
  "reports.monthlyIndoorReport": "Ежемесячный отчет о помещении",
  "reports.monthlyOutdoorReport": "Ежемесячный отчет на открытом воздухе",
  "reports.monthlyReport": "Ежемесячный отчет",
  "reports.monthlySolarReport": "Ежемесячный отчет о солнечной энергии",
  "reports.monthlyWindReport": "Ежемесячный отчет о ветре",
  "reports.numberOfDays": "Количество дней",
  "reports.onThisDayInHistory": "В этот день в истории",
  "reports.outdoorReport": "Открытый отчет",
  "reports.rainfall": "Осадки",
  "reports.rainyDays": "Дождливые дни",
  "reports.recordDailyRain": "Самый дождливый день",
  "reports.recordHigh": "Рекорд тепла",
  "reports.recordLow": "Рекорд холода",
  "reports.recordsAndClimatology": "Рекорды и климат",
  "reports.recordsSince": "Рекорды с {date}",
  "reports.recordWindGust": "Сильнейший порыв ветра",
  "reports.relativelyWet": "Относительно влажно (60 % {lessThan} влажность ≤ 80 %).",
  "reports.sendEmail": "Отправить письмо",
  "reports.summerDays": "Летние дни",
  "reports.tooDry": "Слишком сухо (влажность ≤ 45%)",
  "reports.tooWet": "Слишком влажно (влажность {greaterThan} 80%)",
  "reports.tropicalNights": "Тропические ночи",
  "reports.warmestMonthRanking": "Самый тёплый {month} за историю наблюдений",
  "reports.waterBalance": "Водный баланс",
  "reports.yearsOfData": "{years, plural, one {# год} few {# года} many {# лет} other {# года}} данных",
  "reports.yearToDateTemperature": "Текущая температура",
  "reports.yearToDateTemperatureComparison": "Сравнение температуры за текущий год",
  "sensors.aqiByChannel": "AQI по каналу",
  "sensors.bgtSensors": "Чёрный шар и WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareAqi": "Сравнить AQI",
  "sensors.compareHumidity": "Сравнить влажность",
  "sensors.compareMoisture": "Сравнить влажность почвы",
  "sensors.comparePm25": "Сравнить PM2.5",
  "sensors.compareTemperatures": "Сравнить температуры",
  "sensors.depthByChannel": "Глубина по каналу",
  "sensors.heatStressExtreme": "Экстремальный тепловой стресс",
  "sensors.heatStressModerate": "Умеренный тепловой стресс",
  "sensors.heatStressNone": "Нет теплового стресса",
  "sensors.heatStressStrong": "Сильный тепловой стресс",
  "sensors.heatStressVeryStrong": "Очень сильный тепловой стресс",
  "sensors.humidityByChannel": "Влажность по каналу",
  "sensors.indoorAirQuality": "Качество воздуха в помещении",
  "sensors.indoorAirQualityPm": "PM2.5 и PM10 AQI",
  "sensors.indoorClimate": "Микроклимат",
  "sensors.indoorCo2Levels": "Уровни CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура и влажность",
  "sensors.last24Hours": "24 часа",
  "sensors.last30Days": "30 дней",
  "sensors.last7Days": "7 дней",
  "sensors.leafTemperatureByChannel": "Температура листьев по каналу",
  "sensors.leafWetnessByChannel": "Влажность листьев по каналу",
  "sensors.lightningSensor": "Молния",
  "sensors.moistureByChannel": "Влажность почвы по каналу",
  "sensors.noDataAvailable": "Нет данных",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 по каналу",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Выберите канал",
  "sensors.sensorDetailDescription": "Просмотр исторических данных и трендов по каналам датчика.",
  "sensors.sensorHistory": "История датчика",
  "sensors.soilConductivityByChannel": "Проводимость по каналу",
  "sensors.soilTemperatureByChannel": "Температура почвы по каналу",
  "sensors.strikesToday": "Удары сегодня",
  "sensors.temperatureByChannel": "Температура по каналу",
  "sensors.viewChart": "Показать график",
  "settings.about": "О",
  "settings.aboutDescription": "Лицензионное соглашение, политика конфиденциальности",
  "settings.account": "Счет",
  "settings.accountDescription": "Профиль, смена пароля",
  "settings.accountIntro": "Данные касаются вашей учетной записи:",
  "settings.accountSection": "Аккаунт",
  "settings.appearance": "Оформление",
  "settings.appearanceDescription": "Тема и параметры отображения",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "арабский",
  "settings.availableServices": "Доступные",
  "settings.bulgarian": "болгарский",
  "settings.cannotDisconnectLastAccount": "Невозможно отключить единственный способ входа. Сначала добавьте другой способ входа.",
  "settings.catalan": "каталанский",
  "settings.changeEmail": "Изменить электронную почту",
  "settings.changePassword": "Изменить пароль",
  "settings.chartGestures": "Жесты на графиках",
  "settings.chartGesturesDescription": "Проведение по графикам меняет период времени, сведение графиков меняет временной масштаб.",
  "settings.connect": "Подключить",
  "settings.connected": "Подключено",
  "settings.connectedAccounts": "Привязанные аккаунты",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Подключено",
  "settings.connectedSince": "Подключено с {date}",
  "settings.connectionSuccess": "Аккаунт {provider} успешно подключен",
  "settings.contactUs": "Связаться с нами",
  "settings.contactUsDescription": "Получите помощь или отправьте отзыв",
  "settings.croatian": "хорватский",
  "settings.currentPassword": "Текущий пароль",
  "settings.czech": "чешский",
  "settings.danish": "датский",
  "settings.dark": "Темная тема",
  "settings.dataDisplay": "Отображение данных",
  "settings.dateAndTime": "Дата и время",
  "settings.disconnect": "Отключить",
  "settings.disconnectConfirmation": "Вы уверены, что хотите отключить аккаунт {provider}?",
  "settings.disconnectionSuccess": "Аккаунт {provider} успешно отключен",
  "settings.donateButton": "Сделать пожертвование",
  "settings.donateDescription": "SmartMixin создаёт небольшая команда. Если приложение вам полезно, вы можете поддержать его развитие разовым пожертвованием на любую сумму. Это подарок — он не меняет ваш тариф и не открывает никаких функций.",
  "settings.donateSuccessBody": "Ваше пожертвование помогает SmartMixin работать и становиться лучше. Мы искренне это ценим.",
  "settings.donateSuccessTitle": "Спасибо за вашу поддержку!",
  "settings.donateTitle": "Поддержите SmartMixin",
  "settings.dutch": "голландский",
  "settings.emailChange": "Изменить адрес электронной почты",
  "settings.emailChangeConfirmation": "Подтверждение изменения электронной почты",
  "settings.emailChangeFailure": "Ссылка для изменения электронной почты недействительна или истекла.",
  "settings.emailChangeSuccess": "Ваш адрес электронной почты успешно изменен на {newEmail}.",
  "settings.emailChangeVerificationSent": "Письмо с подтверждением отправлено на ваш новый адрес электронной почты. Проверьте входящие сообщения и нажмите на ссылку для подтверждения изменения.",
  "settings.english": "английский",
  "settings.forecastModelOrderEmpty": "Порядок не сохранён — по умолчанию используется GFS.",
  "settings.forecastModelOrderFreeHint": "Премиум-модели требуют подписки SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Мы выбираем первую модель из вашего списка, которая охватывает каждую станцию.",
  "settings.forecastModelOrderReset": "Сбросить",
  "settings.forecastModelOrderTitle": "Модель прогноза по умолчанию",
  "settings.forecastModels": "Модели прогноза",
  "settings.forecastModelsDescription": "Изменить порядок по предпочтению",
  "settings.french": "французский",
  "settings.german": "немецкий",
  "settings.gestures": "Жесты",
  "settings.greek": "греческий",
  "settings.helpCenter": "Справочный центр",
  "settings.helpCenterDescription": "Часто задаваемые вопросы и руководства",
  "settings.hungarian": "венгерский",
  "settings.integrationsSection": "Интеграции",
  "settings.italian": "итальянский",
  "settings.japanese": "японский",
  "settings.korean": "корейский",
  "settings.language": "Язык",
  "settings.languageDescription": "Предпочтительный язык",
  "settings.light": "Светлая тема",
  "settings.newEmailAddress": "Новый адрес электронной почты",
  "settings.newPassword": "Новый пароль",
  "settings.newPasswordAgain": "Новый пароль еще раз",
  "settings.norwegian": "норвежский",
  "settings.notConnected": "Не подключено",
  "settings.notificationsSection": "Уведомления",
  "settings.oldPassword": "Старый пароль",
  "settings.ongoingNotificationEnabled": "Включить постоянное уведомление",
  "settings.ongoingNotificationMetrics": "Отображаемые показатели",
  "settings.ongoingNotificationMetricsHint": "Перетащите для изменения порядка выбранных показателей",
  "settings.ongoingNotificationPermissionRequired": "Требуется разрешение на уведомления",
  "settings.ongoingNotificationStation": "Метеостанция",
  "settings.passwordChange": "Изменение пароля",
  "settings.polish": "польский",
  "settings.portuguese": "португальский",
  "settings.preferencesSection": "Настройки",
  "settings.premium": "Премиум",
  "settings.premiumActive": "Активна",
  "settings.premiumAnnualThenPrice": "Затем 9,99 €/год",
  "settings.premiumAnnualTrialInfo": "Начните с бесплатного пробного периода на {days} дней",
  "settings.premiumCurrentPlan": "Текущий план",
  "settings.premiumDescription": "Разблокируйте премиум-функции",
  "settings.premiumDownloadApp": "Загрузите приложение для подписки:",
  "settings.premiumExpiresOn": "Продление {date}",
  "settings.premiumFreePlan": "Бесплатно",
  "settings.premiumInactive": "Нет подписки",
  "settings.premiumManageWebSubscription": "Управляйте подпиской, обновите способ оплаты или отмените.",
  "settings.premiumPremiumPlan": "Премиум",
  "settings.premiumSubscribeAnnual": "Ежегодно — 9,99 €/год",
  "settings.premiumSubscribedOn": "Подписка на {platform}",
  "settings.premiumSubscribeMonthly": "Ежемесячно — 1,99 €/месяц",
  "settings.premiumSubscribeOnWeb": "Подпишитесь сейчас, чтобы разблокировать все премиум-функции.",
  "settings.premiumSubscriptionSuccess": "Ваша подписка активирована! Наслаждайтесь всеми премиум-функциями.",
  "settings.premiumSubscriptionSuccessTitle": "Добро пожаловать в Premium!",
  "settings.premiumWebappNotice": "Подписки можно приобрести только через мобильное приложение SmartMixin на iOS или Android.",
  "settings.privacyPolicy": "Политика конфиденциальности",
  "settings.profile": "Профиль",
  "settings.russian": "русский",
  "settings.serbian": "сербский",
  "settings.settings": "Настройки",
  "settings.slovak": "словацкий",
  "settings.smallDecimals": "Мелкие десятичные",
  "settings.smallDecimalsDescription": "Отображать десятичные цифры меньшим размером",
  "settings.socialConnectionsIntro": "Свяжите свои социальные аккаунты для быстрого входа. Вы можете подключить или отключить аккаунты в любое время.",
  "settings.spanish": "испанский",
  "settings.statusBarWidget": "Виджет строки состояния",
  "settings.statusBarWidgetDescription": "Всегда видимые данные о погоде",
  "settings.subscriptionSection": "Подписка",
  "settings.supportSection": "Поддержка",
  "settings.swedish": "шведский",
  "settings.systemTheme": "Системная тема",
  "settings.termsOfService": "Условия использования",
  "settings.turkish": "турецкий",
  "settings.ukrainian": "украинский",
  "settings.units": "Единицы",
  "settings.unitsDescription": "Единицы измерения, отображаемые в приложении",
  "settings.update": "Обновить",
  "settings.updateYourProfile": "Обновите профиль",
  "settings.weatherServices": "Метеорологические сервисы",
  "settings.weatherServicesConnected": "{count, plural, =0 {Нет подключенных сервисов} one {# сервис подключен} few {# сервиса подключено} many {# сервисов подключено} other {# сервисов подключено}}",
  "settings.weatherServicesDescription": "Подключите Netatmo, Davis, Weatherflow и другие",
  "settings.windDirectionConvention": "Стрелка направления ветра",
  "settings.windDirectionConventionDescription": "Выберите отображение стрелок направления ветра",
  "settings.windDirectionMeteorological": "Направление источника",
  "settings.windDirectionMeteorologicalDescription": "Стрелка указывает, откуда дует ветер (метеорологическая конвенция)",
  "settings.windDirectionOceanographic": "Направление потока",
  "settings.windDirectionOceanographicDescription": "Стрелка указывает, куда дует ветер (океанографическая конвенция)",
  "units.absolutePressure": "Абсолютное давление",
  "units.airDensity": "Плотность воздуха",
  "units.airGap": "Воздушный зазор",
  "units.apparentTemperature": "Ощущаемая температура",
  "units.AQI": "АКИ",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Среднее",
  "units.beaufort": "Бофорт",
  "units.blackGlobeTemperature": "Темп. чёрного шара",
  "units.boilerOn": "Котел ВКЛ.",
  "units.co2": "СО2",
  "units.conductivity": "Проводимость",
  "units.coolingDegreeDays": "Градусные дни охлаждения",
  "units.dailyHeatingDuration": "Ежедневная продолжительность отопления",
  "units.dailyPrecipitation": "Суточные осадки",
  "units.dailyRain": "Суточные осадки",
  "units.degreeDay": "Градусный день",
  "units.degreeDayShort": "ДД",
  "units.depth": "Глубина",
  "units.depthSensors": "Датчики глубины",
  "units.dewPoint": "точка росы",
  "units.distance": "Расстояние",
  "units.downTrend": "вниз",
  "units.E": "В",
  "units.E_long": "Восток",
  "units.ENE": "ВСВ",
  "units.ENE_long": "Восток-Северо-Восток",
  "units.ESE": "ВЮВ",
  "units.ESE_long": "Восток-Юго-Восток",
  "units.ET": "Эвапотранспирация",
  "units.ETshort": "ET",
  "units.feelLike": "Ощущается как",
  "units.feelsLike": "Ощущается как",
  "units.footMile": "Фут, миля",
  "units.frostPoint": "Точка замерзания",
  "units.gust": "Порыв",
  "units.heatIndex": "Индекс тепла",
  "units.heatingDegreeDays": "Градус-дни отопления",
  "units.heatingPower": "Мощность нагрева",
  "units.humidex": "Гумидекс",
  "units.humidity": "Влажность",
  "units.inch": "Дюйм",
  "units.inchOfMercury": "Дюйм ртутного столба",
  "units.kilometerPerHour": "Километры в час",
  "units.knot": "Морской узел",
  "units.last12Hours": "Последние 12 часов",
  "units.last24Hours": "Последние 24 часа",
  "units.last3Hours": "Последние 3 часа",
  "units.last6Hours": "Последние 6 часов",
  "units.lastHour": "Последний час",
  "units.lastLightningImpact": "Последний удар",
  "units.lastMeasure": "Последняя мера",
  "units.leafSensors": "Датчики листьев",
  "units.leafWetness": "Влажность листьев",
  "units.lightningDistance": "Расстояние",
  "units.lightningStrikeCount": "Количество ударов молнии",
  "units.lightningStrikeDistance": "Расстояние удара молнии",
  "units.max": "Макс.",
  "units.max_gust": "Макс. порыв",
  "units.max_wind": "Макс. ветер",
  "units.meterKilometer": "Метр, километр",
  "units.meterPerSecond": "Метры в секунду",
  "units.milePerHour": "Миль в час",
  "units.millibar": "Миллибар",
  "units.millimeter": "Миллиметр",
  "units.millimeterOfMercury": "Миллиметр ртутного столба",
  "units.min": "Мин.",
  "units.N": "С",
  "units.N_long": "Север",
  "units.NE": "СВ",
  "units.NE_long": "К северо-востоку",
  "units.NNE": "Северо-северо-восток",
  "units.NNE_long": "Северо-Северо-Восток",
  "units.NNW": "Северо-северо-запад",
  "units.NNW_long": "Северо-Северо-Запад",
  "units.noise": "Шум",
  "units.normalizedHeatingCoefficient": "Нормированный коэффициент нагрева",
  "units.NW": "СЗ",
  "units.NW_long": "Северо-Запад",
  "units.O3": "Озон",
  "units.PM_1": "ПМ1",
  "units.PM_10": "ТЧ10",
  "units.PM_2P5": "ТЧ2,5",
  "units.precipitation": "Атмосферные осадки",
  "units.pressure": "Давление",
  "units.rain": "Дождь",
  "units.rainRate": "Интенсивность дождя",
  "units.referenceTemperature": "Эталонная температура",
  "units.relativePressure": "Относительное давление",
  "units.S": "Ю",
  "units.S_long": "Юг",
  "units.SE": "ЮВ",
  "units.SE_long": "Юго-восток",
  "units.setPoint": "Уставка",
  "units.snow": "Снег",
  "units.snowfall": "Снегопад",
  "units.soilMoisture": "Влага",
  "units.soilSensors": "Датчики почвы",
  "units.solarEnergy": "Солнечная энергия",
  "units.solarRadiation": "Солнечная радиация",
  "units.speed": "Скорость",
  "units.SSE": "ЮЮВ",
  "units.SSE_long": "Юго-Юго-Восток",
  "units.SSW": "ЮЮЗ",
  "units.SSW_long": "Юго-Юго-Запад",
  "units.stableTrend": "стабильный",
  "units.sum": "Сумма",
  "units.SW": "ЮЗ",
  "units.SW_long": "Юго-запад",
  "units.temperature": "Температура",
  "units.temperatureAndHumiditySensors": "Датчики температуры и влажности",
  "units.temperatureSensors": "Датчики температуры и влажности",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Сегодня",
  "units.upTrend": "вверх",
  "units.uv": "УФ",
  "units.visibility": "Видимость",
  "units.W": "З",
  "units.W_long": "Запад",
  "units.wetBulbGlobeTemperature": "Темп. влажного шара",
  "units.wetBulbTemperature": "Температура влажного термометра.",
  "units.wind": "Ветер",
  "units.windChill": "Холодный ветер",
  "units.windDirection": "Направление ветра",
  "units.windRun": "Ветер бег",
  "units.windRunDescription": "Ветровой пробег — это общее расстояние, пройденное ветром за определенный период времени.",
  "units.WNW": "ЗСЗ",
  "units.WNW_long": "Запад-Северо-Запад",
  "units.WSW": "ЗЮЗ",
  "units.WSW_long": "Запад-Юго-Запад"
}
